enum Color {
  PRIMARY = '#215891',
  INFO = '#2DB7F5',
  SUCCESS = '#67C23A',
  WARNING = '#E6A23C',
  DANGER = '#FF756F',
}

export default Color;
